<template>
  <div id="app">
    <Navbar
      :transparent="$route.path === '/home'"
      :class="{ 'nav-desktop': $store.state.wallet.connected }"
    ></Navbar>
    <NavbarMobile v-if="$store.state.wallet.connected" class="nav-mobile" />
    <VillageNavMobile v-if="$store.state.wallet.connected" />
    <FogoWallet />
    <router-view style="margin-bottom: 60px" />
    <portal-target name="body"></portal-target>
  </div>
</template>

<style>
.toast-title:has(.toast-explorer-link) {
  display: flex;
  align-items: center;
  gap: 8px;
}

.toast-explorer-link {
  display: block;
  box-sizing: content-box;
  min-width: 12px;
  width: 12px;
  min-height: 12px;
  height: 12px;
  margin-left: auto;
  flex-shrink: 0;
  opacity: 0.8;
  background: currentColor;
  -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6'/%3E%3Cpolyline points='15 3 21 3 21 9'/%3E%3Cline x1='10' y1='14' x2='21' y2='3'/%3E%3C/svg%3E") no-repeat center / contain;
  mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6'/%3E%3Cpolyline points='15 3 21 3 21 9'/%3E%3Cline x1='10' y1='14' x2='21' y2='3'/%3E%3C/svg%3E") no-repeat center / contain;
}
</style>

<script>
import Navbar from "@/components/home/Navbar.vue";
import FogoWallet from "./components/fogo/FogoWallet.vue";
import { toast } from "./composables/useToast";
import NavbarMobile from "./components/home/NavbarMobile.vue";
import VillageNavMobile from "@/components/village/VillageNavMobile.vue";

export default {
  name: "App",
  components: { Navbar, FogoWallet, NavbarMobile, VillageNavMobile },

  mounted() {
    toast.init(this.$toastr);
  },
};
</script>

<style scoped></style>
